/**
 * Traducciones del FORMULARIO de contacto: los estados de envío y lo que
 * se le dice a quien escribe cuando algo sale bien o mal.
 *
 * ── Por qué está aparte de `shop.ts` ─────────────────────────────────
 * Los textos de la SECCIÓN de contacto —"Contacto", "Hablemos.", los tres
 * canales de la columna izquierda— ya viven en `shop.ts`, que es el mapa
 * de la tienda. Aquí solo están las claves NUEVAS que trajo el formulario
 * cuando dejó de mentir y empezó a hablar con el servidor: enviando,
 * enviado, y los errores.
 *
 * Van en su propio archivo para no pelear con quien esté editando
 * `shop.ts` en paralelo — es la misma razón por la que los mapas están
 * partidos por área desde el principio.
 *
 * ── Cómo se lee esto ─────────────────────────────────────────────────
 * La CLAVE es el texto en español; el valor, su inglés. El español no
 * necesita mapa: cuando falta la traducción, i18next devuelve la clave.
 */
export const contactEn: Record<string, string> = {
  // ── Campos ────────────────────────────────────────────────────────
  "Tu nombre": "Your name",
  "¿En qué podemos ayudarte?": "How can we help you?",

  // ── Envío ─────────────────────────────────────────────────────────
  //
  // "Enviando…" no se ve: es el `aria-label` del botón mientras carga. El
  // botón esconde su texto para no cambiar de ancho, y eso lo deja sin
  // nombre para un lector de pantalla justo cuando más falta hace.
  "Enviando…": "Sending…",

  /**
   * El mensaje de éxito. Ahora solo aparece cuando el SERVIDOR confirmó
   * que guardó el mensaje — antes salía siempre, sin haber enviado nada a
   * ningún sitio.
   *
   * Dice "recibimos", no "enviamos": es exactamente lo que el servidor
   * promete (`received: true`). El aviso por correo a la tienda puede
   * fallar sin que el mensaje se pierda, y esta frase sigue siendo cierta
   * en los dos casos.
   */
  "Recibimos tu mensaje. Te responderemos muy pronto.":
    "We got your message. We'll get back to you very soon.",

  // ── Error ─────────────────────────────────────────────────────────
  //
  // Se enseña cuando el servidor no pudo guardar el mensaje. Lleva la
  // salida al lado —el correo directo, que está a la izquierda en la misma
  // sección— porque un error sin alternativa deja a alguien atrapado.
  "No pudimos enviar tu mensaje": "We couldn't send your message",
  "Vuelve a intentarlo en un momento o escríbenos directo a hola@itsthebest1111.com.":
    "Try again in a moment, or email us directly at hola@itsthebest1111.com.",
  "Ya nos escribiste varias veces. Intenta de nuevo en una hora":
    "You've written to us several times already. Try again in an hour",
};
